<template>
  <!-- Confidence ring (approved Engineering grid): track + arc filled to the value, banded green / amber / red, number inside -->
  <span class="ring" :class="`ring--${band}`" :title="label" :aria-label="`${percent} percent`">
    <svg viewBox="0 0 34 34" width="34" height="34" aria-hidden="true">
      <circle cx="17" cy="17" :r="radius" fill="none" stroke="var(--aa-border-default)" stroke-width="3" />
      <circle cx="17" cy="17" :r="radius" fill="none" stroke="var(--ring-stroke)" stroke-width="3" stroke-linecap="round" :stroke-dasharray="arc" transform="rotate(-90 17 17)" />
    </svg>
    <b>{{ percent }}</b>
  </span>
</template>

<script>
  import { RING_RADIUS, ringArc, ringBand } from '../../utils/reportFormat';

  const PERCENT = 100;

  export default {
    name: 'ConfidenceRing',
    props: {
      value: { type: Number, default: 0 },
    },
    data() {
      return { radius: RING_RADIUS };
    },
    computed: {
      percent() {
        return Math.round((Number(this.value) || 0) * PERCENT);
      },
      band() {
        return ringBand(this.value);
      },
      arc() {
        return ringArc(this.value);
      },
      label() {
        return `${this.percent}%`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ring {
    position: relative;
    display: inline-grid;
    place-items: center;
    width: 34px;
    height: 34px;
    vertical-align: middle;

    svg { position: absolute; inset: 0; }
    b { position: relative; font-family: var(--ds-font-family-mono) !important; font-size: var(--aa-grid-font-id); font-weight: 600; line-height: 1; }

    &--high { --ring-stroke: var(--aa-brand); b { color: var(--aa-brand); } }
    &--mid { --ring-stroke: var(--aa-ring-mid); b { color: var(--aa-ring-mid-text); } }
    &--low { --ring-stroke: var(--aa-error); b { color: var(--aa-error); } }
  }
</style>
